import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="text-center py-5 footer">
      <div className="address-div">
        <FontAwesomeIcon icon={faLocationDot} className="contact-icon" />
        <p className="m-0" >
          7901 4TH ST N STE 28279 <br /> ST PETERSBURG FL 33702
        </p>
      </div>
      &copy; 2025 Livosol
    </div>
  );
};

export default Footer;
